module.exports = __webpack_public_path__ + "static/media/rsrcmtr_129.b7eee6f6.ico";